import {
  AIScanFoodOptionType,
  FoodType,
  IngredientType,
} from "model/food/types"
import {
  isEdamaFood,
  isOpenFoodFactFood,
} from "model/food/utils/typeGuards/foodTypeGuards"

export const getFoodBrand = (
  food: FoodType | AIScanFoodOptionType | IngredientType,
) => {
  if (isEdamaFood(food) || isOpenFoodFactFood(food)) {
    return food.brand
  }

  return null
}
